<div id="top-of-page"></div>
<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2">Porta un amico</h3>

<p class="ms-2 mt-3">Con <strong>Beizy</strong>, l'unione fa la forza!</p>
<p class="mt-3 ms-2">Visualizza le tue richieste qui sotto. Ti aggiorniamo noi quando il tuo bonus è pronto! </p>

<mat-card class="mb-1">
  <mat-card-content class="m-0">
    <div class="d-flex justify-content-between align-items-center">
      Come funzionano le richieste?

    <button 
      mat-stroked-button 
      color="primary"
      class="ms-2 hidden-mobile attachment-button"
      (click)="redirectToPortaUnAmico()"
    >
      <mat-icon>explore</mat-icon>
      Leggi le linee guida
    </button>
    <!-- mobile version  -->
    <button 
      mat-stroked-button 
      color="primary"
      class="m-0 align-items-center text-center visible-mobile attachment-button flex-shrink-0"
      (click)="redirectToPortaUnAmico()"
    >
      <mat-icon class="ms-2">explore</mat-icon>
      Apri
    </button>
    </div>

  </mat-card-content>
</mat-card>

<div class="mt-2 mb-2 d-flex justify-content-between align-items-center">
  <h5 class="mt-3 mb-3 ms-2">Richieste attive:</h5>
  <span>
    <button 
      mat-raised-button
      matButton="filled"
      class="ms-2 me-3 hidden-mobile custom-button"
      (click)="openNewReferralDialog()"
    >
      <mat-icon>add</mat-icon>
      Nuova richiesta
    </button>
    <button 
      mat-raised-button
      matButton="filled"
      class="ms-2 visible-mobile custom-button"
      (click)="openNewReferralDialog()"
    >
      <mat-icon>add</mat-icon>
      Richiesta
    </button>
  </span>
</div>

<!-- Loading State -->
  <div *ngIf="isLoading">
    <div class="loadidiv d-flex flex-column justify-content-center align-items-center py-5">
      
      <p class="mt-3">Caricamento in corso...</p>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="allReferralRequests.length === 0">
    <div class="loadidiv d-flex flex-column justify-content-center align-items-center py-5" class="empty-container">
      <mat-icon>groups</mat-icon>
      <h4>Nessuna richiesta trovata...</h4>
      <p class="mt-3">Invita una Partita IVA ed entrambi otterrete un bonus!</p>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <button 
        mat-stroked-button 
        color="primary"
        class="ms-2 mt-3 attachment-button"
        (click)="redirectToPortaUnAmico()"
      >
      <mat-icon>explore</mat-icon>
        Leggi le linee guida
      </button>
    </div>
  </div>

  <!-- allReferralRequests List -->
  <div *ngFor="let document of allReferralRequests" class="document-item">
    <mat-card class="contract-card mb-1">
      <mat-card-content class="m-0">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h6 class="mb-1">{{document.name}}</h6>
            <p class="text-muted mb-0 small">
              <mat-icon class="me-1" style="vertical-align: middle; font-size: 16px;">
                accessibility_new
              </mat-icon>
              {{document.name}}
            </p>
            <p class="text-muted mb-0 small">
              <mat-icon class="me-1" style="vertical-align: middle; font-size: 16px;">
                mail
              </mat-icon>
              {{document.mail}}
            </p>
            <div>
              <mat-chip class="mt-1 text-muted mb-0 small">
                {{ getReferralTypeDisplay(document.status) }}
              </mat-chip>
            </div>    
          </div>        
          
          <button 
            mat-stroked-button 
            color="primary"
            class="ms-2 hidden-mobile attachment-button"
            (click)="openReferralDetailsDialog(document)"
          >
            <mat-icon>visibility</mat-icon>
            Visualizza la richiesta
          </button>
          <!-- mobile version  -->
          <button 
            mat-stroked-button 
            color="primary"
            class="m-0 align-items-center text-center visible-mobile attachment-button"
            (click)="openReferralDetailsDialog(document)"
          >
            <mat-icon class="ms-2">visibility</mat-icon>
            Vedi
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>